

import React from "react";

import { useDispatch } from "react-redux";
import { useRouteMatch,Switch, Route } from "react-router-dom";
import {  Link  } from "react-router-dom";
import {Activity,Settings,MonitorPlay } from 'lucide-react';
const CardCourseMinimizedBlank = ({}) =>{
    const {url}=useRouteMatch();
    const dispatch = useDispatch();

    
return(<><div>
<div align="center" class="card-big-long-app-course-outer" style={{border:"2px solid #f1f1f1",background:" #f9f9f9",marginTop:"50px"}}>
<div  className={`card-big-long-app-course-top `} >
<div  className="create-card-title" style={{textAlign: "left",padding:"10px",color:"#444444"}}>
                   
                  
                   </div>  <div   className="create-card-icon-top" >
                           
                          
                         
                         </div>
                   </div> 
        <div  className={`  `} >
        <div  className={` `} >
               <div className=""  style={{margin:'10px',marginTop:'15px',
                    background:"",borderRadius:"15px"}}>
              <button  className="AppCardsCourseButtonTwo"   style={{border:"2px solid #f1f1f1",borderRadius:"10px",background:"#dddddd",padding:"20px"}}
    >   </button>  </div>  </div> </div></div>
                
                </div>

</>)
}
export default CardCourseMinimizedBlank;